import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class HlPercentageStatusWiseResponseModel extends GlobalResponseObject {
    active?: number;
    inActive?: number;
    total?: number;
}
